import { useState } from "react";
import { FAQ_CONTENT } from "../utils/constants";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_CONTENT.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq-section" id="faq">
      <div className="section-heading">
        <span className="eyebrow">FAQ</span>
        <h2>Common Questions</h2>
        <p>Straight answers before you reach out.</p>
      </div>

      <div className="faq-list">
        {FAQ_CONTENT.map((item, index) => {
          const isOpen = index === openIndex;
          return (
            <div className={`faq-item ${isOpen ? "open" : ""}`} key={item.question}>
              <button
                className="faq-question"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
              >
                {item.question}
                <span className="faq-icon">{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-answer">{item.answer}</p>}
            </div>
          );
        })}
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
};

export default FAQ;
